import type { HotelContent } from '../../selectors/michelinTypes';

export type TransformedHotelContent = {
  name: string;
  imageUrl: string | undefined;
  stars: number;
  reviewScore: number | undefined;
  distanceLabel: string | undefined;
};

export const transformHotelContent = (
  hotelContent: HotelContent,
): TransformedHotelContent => ({
  name: hotelContent.name ?? '',
  imageUrl: hotelContent.gallery?.images?.[0]?.url,
  stars: hotelContent.stars?.level ?? 0,
  reviewScore: hotelContent.reviewSummary?.score,
  distanceLabel: hotelContent.distanceReference?.distanceDescription,
});
